<script lang="ts" setup>
import { computed } from 'vue';
import LazyVisible from '@/components/common/lazy-visible.vue';
import { useThemeKeywordFeedCounts, useThemeList } from '@/utils/swr';
import { useStore } from '@/utils/vue';
import FavoriteThemeArticles from './favorite-theme-articles.vue';
import FavoriteThemeSelect from './favorite-theme-select.vue';

const store = useStore();
const feedType = computed(() => store.state.feedType.feedType);
const { data: themes } = useThemeList(feedType);
const { data: themeKeywordFeedCounts } = useThemeKeywordFeedCounts(feedType);

const getThemeKeywordFeedCount = (themeId: number) =>
  themeKeywordFeedCounts.value?.theme_keyword_feed_counts[String(themeId)] ?? 0;

const activeThemes = computed(() =>
  (themes.value?.themes ?? []).filter(t => !t.is_deleted),
);
const favoriteThemes = computed(() =>
  activeThemes.value
    .filter(t => t.is_favorite)
    .sort((a, b) => a.order - b.order),
);
</script>

<template>
  <TransitionGroup
    name="favorite-theme"
    tag="div"
    class="favorite-themes-section"
  >
    <LazyVisible
      v-for="theme in favoriteThemes"
      :key="theme.id"
      class="theme-wrapper"
    >
      <FavoriteThemeArticles
        :theme="theme"
        :article-count="getThemeKeywordFeedCount(theme.id)"
      />
    </LazyVisible>
    <LazyVisible key="favorite-theme-select">
      <FavoriteThemeSelect class="theme-wrapper" />
    </LazyVisible>
  </TransitionGroup>
</template>

<style lang="scss" scoped>
.favorite-themes-section {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .theme-wrapper {
    content-visibility: auto;
    contain-intrinsic-size: auto 400px;
  }
}

.favorite-theme-move {
  transition: transform 0.3s ease;
}
</style>
